import React from "react";
import Typography from "@material-ui/core/Typography";
import PostAddIcon from "@material-ui/icons/PostAdd";
import ScheduleIcon from "@material-ui/icons/Schedule";
import RoomIcon from "@material-ui/icons/Room";
import Filter from "../images/icons/filter";

const res = {
  "newStory": "Neue hiStory",
  "newStoryTooltipHeader": "Eine neue hiStory erstellen",
  "newStoryTooltipBody": "Erstellt den Rahmen für deine Erzählung, die Timeline und die Ereignisse.",
  "newEventTooltipHeader": "Ein neues Ereignis erstellen",
  "newEvent": "Neues Ereignis",
  "newEventTooltipBody1": "Erstellt ein neues Ereignis in der Timeline.",
  "newEventTooltipBody2": "Erstelle das Ereignis über das Kontextmenü ",
  "newEventTooltipBody3": "(Linksklick auf freie\nStelle)",
  "newEventTooltipBody4": " in der Timeline, falls du den Zeitpunkt direkt vorbelegen möchtest.",
  "search": "Suchen",
  "searchEventsAndStories": "Ereignisse und hiStories suchen",
  "searchEventsAndStoriesTooltip1": "- Suche nach Ereignissen in der Timeline während des Tippens",
  "searchEventsAndStoriesTooltip2": "- Suche nach hiStories",
  "filter": "Filtern",
  "filterEvents": "Ereignisse ausfiltern",
  "filterEventsTooltip1": "Ereignisse nach verschiedenen Kriterien ein- und ausblenden",
  "measure": "Zeiten messen",
  "measureTooltip": "Zeiten messen in der Timeline",
  "help": "Hilfe",
  "more": "mehr...",
  "loginInfoNotLoggedIn": "Du bist nicht angemeldet",
  "loginInfoDoLoginHere": "Hier anmelden.",
  "login": "Anmelden",
  "loginWithGoogle": "Anmelden mit Google",
  "loginWithFacebook": "Anmelden mit Facebook",
  "loginWithVIDIS": "Anmelden mit Schulaccount (VIDIS)",
  "loginWithFobizz": "Anmelden mit Fobizz",
  "loginWithEdulog": "Anmelden mit Schulaccount (edulog)",
  "storiesNearby": "hiStories in der Nähe",
  "searchStories": "hiStories durchsuchen",
  "myStories": "Meine hiStories",
  "recentlySeen": "Vor kurzem gesehen",
  "usedImagesAndSources": "Die verwendeten Bilder und ihre Quellen.",
  "sourcesOnlyGiven": "Quellen werden nur angegeben, falls der Autor diese hinterlegt hat.",
  "imageSourceReferences": "Bildquellen-Nachweise",
  "settings": "Einstellungen",
  "separatorTimelineDesc": "Trenner für Timeline/Artikeltext",
  "horizontal": "horizontal",
  "vertical": "vertikal",
  "showSidewaysDuringEventSelection": "bei Ereignisauswahl seitlich einblenden",
  "alwaysSuperimpose": "immer überlagernd einblenden",
  "automatic": "automatisch",
  "detailView": "Detailansicht",
  "eventLabeling": "Ereignisbeschriftung",
  "fullLabeling": "volle Beschriftung",
  "maxAsLongAsBar": "maximal so lang wie Ereignsibalken",
  "showTimelineBackgroundImage": "Hintergrundbild der Timeline",
  "showTimelineBackgroundImageTrue": "anzeigen",
  "showTimelineBackgroundImageFalse": "nicht anzeigen",
  "timelineTheme": "Timelinehintergrund",
  "dark": "dunkel",
  "bright": "hell",
  "chooseStory": "hiStory wählen",
  "close": "Schließen",
  "save": "Speichern",
  "ok": "OK",
  "cancel": "Abbrechen",
  "yes": "Ja",
  "no": "Nein",
  "delete": "Löschen",
  "copy": "Kopieren",
  "edit": "Bearbeiten",
  "back": "Zurück",
  "understoodAndSave": "Verstanden und speichern",
  "error": "Fehler",
  "errorInternal": () => (<>Es ist ein unbekannter interner Fehler aufgetreten.<br/>Bitte setze dich mit einem Ansprechpartner von histomania in Verbindung.</>),
  "errorMailOrPwdNotFound": (fatLink, showRequestNewPassword) => (<>Deine E-Mailadresse oder das eingegebene Passwort sind uns nicht bekannt.<br/>Falls du dein Passwort vergessen haben, so fordere bitte <span style={fatLink} onClick={showRequestNewPassword}>hier</span> ein neues an.</>),
  "msgPasswordSent": () => (<>Wir haben dir eine E-Mail mit einem Bestätigungslink gesendet.<br/>Bitte klicken diesen Link an, damit wir dir ein neues Passwort zusenden können.</>),
  "msgNotFound": () => (<>Das angeforderte Ereignis wurde nicht gefunden.<br/>Bitte setze dich mit einem Ansprechpartner von histomania in Verbindung.</>),
  "errorNetwork": () => (<>Es ist ein Fehler aufgetreten.<br/>Bitte stelle eine funktionierende Internetverbindung sicher.</>),
  "msgAccountCreated": () => (<>Dein Konto wurde erstellt.<br/>Wir haben dir deine Anmeldedaten per E-Mail gesendet.<br/>Bitte prüfe eventuell auch deinen Spam-Ordner.</>),
  "errorDuplicateUserEntry": () => (<>Wir konnten dein Konto nicht neu anlegen, da der Benutzer bereits in unserer Datenbank vorhanden war.<br/>Bitte melde dich mit deinen bestehenden Daten an, oder lass dir unter "Passwort vergessen" ein neues Passwort zusenden.</>),
  "errorUserNotFound": () => (<>Der Benutzer existiert nicht.</>),
  "errorUnknown": () => (<>Es ist ein unbekannter Fehler aufgetreten.<br/>Bitte setze dich mit einem Ansprechpartner von histomania in Verbindung.</>),
  "titleNewPasswordRequested": "Neues Passwort angefordert",
  "titleAccountCreated": "Kontoerstellung",
  "or": "oder",
  "createAccount": "Erstelle hier mit wenigen Angaben kostenlos dein neues histomania-Konto",
  "exportToExcel": "Daten nach MS-Excel exportieren",
  "exportToJSON": "Daten nach JSON exportieren",
  "addToWebsite": "Füge die aktuell angezeigten hiStories zu deiner Webseite hinzu, indem du den untenstehenden Code einfügst.",
  "codeMustBeInBodyTag": "Der Code muss innerhalb des body-Tags deines HTML-Dokuments stehen.",
  "embedAcceptAGB": "Indem du Inhalte von histomania in deine Website oder App einbettest, akzeptierst du die Allgemeinen Geschäfts- und Nutzungsbedingungen von histomania.",
  "permissions": "Berechtigungen",
  "profile": "Profil",
  "username": "Benutzername",
  "firstName": "Vorname",
  "lastName": "Nachname",
  "company": "Institution",
  "country": "Land",
  "state": "Bundesland/Kanton",
  "idprovider": "ID-Provider",
  "role": "Rolle",
  "inputFirstName": "Bitte gib deinen Vornamen ein",
  "inputSurName": "Bitte gib deinen Nachnamen ein",
  "newsLetterInfo": "Der Newsletter erscheint etwa 5-6 mal pro Jahr und informiert dich über Neuerungen und ausgewählte hiStories.",
  "subscribeNewsletter": "Newsletter abonnieren",
  "loading": "lade",
  "changePassword": "Passwortänderung",
  "pwdChangeSuccessful": "Dein Passwort wurde erfolgreich geändert.",
  "pwdChangeErr": "Fehler beim Ändern des Passworts.",
  "pwdLength": "Das gewählte Passwort muss mindestens 8 Zeichen enthalten.",
  "pwdRepetitionError": "Das wiederholte Passwort unterscheidet sich vom ersten eingegebenen Passwort.",
  "pwdChange": "Passwort ändern",
  "pwdOld": "Altes Passwort",
  "pwdNew": "Neues Passwort (min. 8 Zeichen)",
  "pwdNewRepetition": "Neues Passwort (Wiederholung)",
  "showWikipediaTooltip": "Wikipedia-Artikel anzeigen",
  "whatIf": "Was wäre, wenn...",
  "changeTime": "Zeit ändern",
  "moveTimelineFromRefDate": "Verschiebe die Timeline von einem Referenzdatum auf ein anderes:",
  "moveTimelineByDuration": "Oder verschiebe um eine bestimmte Dauer:",
  "noteTimelineIsNotSaved": "Hinweis: die geänderte Timeline wird nicht gespeichert.",
  "moveMeasuringStick": "Verschiebe den Messschieber auf die angegebene Zeit",
  "moveMeasuringStickBy": "Messschieber verschieben um:",
  "moveMeasuringStickTo": "Messschieber verschieben auf:",
  "toPast": "in die Vergangenheit",
  "toFuture": "in die Zukunft",
  "imageWithLicenseImg": "***Bild:***",
  "dragNdropHint": "Drag-n-drop einer Datei oder Klick, um Bild zuzufügen",
  "maxFileSize": "Maximale Dateigröße:",
  "info": "Info",
  "attention": "Achtung",
  "articleOnWikipedia": "Artikel auf Wikipedia",
  "wikidataRecord": "Wikidata-Datensatz",
  "showLocationOnGoogleMaps": "Ort auf Google-Maps anzeigen",
  "showStoriesNearby": "Weitere hiStories in der Nähe",
  "showStoriesAtThatTime": "Was war noch zu dieser Zeit?",
  "showVideosOnYoutube": "Videos auf YouTube",
  "showBooksOnAmazon": "Bücher bei Amazon",
  "showDetails": "Details anzeigen",
  "details": "Details",
  "now": "jetzt",
  "closeWithSave": "Vor dem Schließen speichern?",
  "closeWithoutSaveQuestion": () => (<>Klicke auf 'Ja' und speichere deine Änderungen.<br/>Andernfalls gehen deine geänderten Daten verloren.</>),
  "seconds": "Sekunden",
  "minutes": "Minuten",
  "hours": "Stunden",
  "days": "Tage",
  "untilNow": "bis jetzt",
  "secondsUntilNow": "Sekunden bis jetzt",
  "minutesUntilNow": "Minuten bis jetzt",
  "hoursUntilNow": "Stunden bis jetzt",
  "daysUntilNow": "Tage bis jetzt",
  "unknownDuration": "unbekannte Dauer",
  "oClock": "Uhr",
  "pastOrFutureDuration": (isPast, duration) => ((isPast ? "vor " : "in ") + duration),
  "startType": "Art des Starts",
  "endType": "Art des Endes",
  "pointInTime": "Zeitpunkt",
  "born": "geboren",
  "earliest": "frühestens",
  "start": "Start",
  "origin": () => (<span><b>Entstehung</b><br/><Typography variant="caption">oder Gründung/Erstellung</Typography></span>),
  "discovery": "Entdeckung",
  "publication": "Publikation",
  "firstDescription": "Erstbeschreibung",
  "baptized": "getauft",
  "premiere": "Uraufführung",
  "opened": "eröffnet",
  "activeSince": "aktiv seit",
  "died": "gestorben",
  "latest": "spätestens",
  "end": "Ende",
  "decommissioning": "Stilllegung",
  "dissolved": "aufgelöst",
  "lost": "verschollen seit",
  "activeUntil": "aktiv bis",
  "discontinued": "eingestellt",
  "closed": "geschlossen",
  "precision": "Genauigkeit",
  "1000000000years": "1 Mrd Jahre",
  "100000000years": "100 Mio Jahre",
  "10000000years": "10 Mio Jahre",
  "1000000years": "1 Mio Jahre",
  "100000years": "100 Tsd Jahre",
  "10000years": "10 Tsd Jahre",
  "millenium": "Jahrtausend",
  "century": "Jahrhundert",
  "decade": "Jahrzehnt",
  "year": "Jahr",
  "month": "Monat",
  "day": "Tag",
  "hour": "Stunde",
  "minute": "Minute",
  "exact": "exakt",
  "duration": "Dauer",
  "years": "Jahre",
  "mon.": "Mon.",
  "h.": "Std.",
  "min.": "Min.",
  "noTimeChosen": "Kein Datum ausgewählt",
  "today": "heute",
  "weekdays": () => (["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"]),
  "internalServerError": () => (<div>Es ist ein interner Serverfehler aufgetreten.<br/>Bitte setze dich mit einem Ansprechpartner von histomania in Verbindung.</div>),
  "userNotAcknowledged": () => (<div>Der Benutzer ist in unserem System vorhanden, er wurde aber noch nicht von Ihnen über den Link in der E-Mail bestätigt.</div>),
  "userOrPwdNotInSystem": () => (<div>Der Benutzer oder das eingegebene Passwort sind uns nicht bekannt.</div>),
  "oldPasswordUnknown": () => (<div>Das alte Kennwort ist uns nicht bekannt.</div>),
  "pwdGuideline": () => (<div>Die eingegebenen Daten entsprechen nicht den Richtlinien.</div>),
  "noDataRefresh": () => (<div>Daten konnten nicht aktualisiert werden.</div>),
  "emailAlreadyAvailable": () => (<div>Die eingegebene E-Mailadresse ist bereits vorhanden</div>),
  "userNotCreated": () => (<div>Der Benutzer konnte nicht angelegt werden</div>),
  "reCaptchaError": () => (<div>Google reCaptcha: Du konntest nicht als Mensch identifiziert werden.</div>),
  "notPlausible": () => (<div>Die Eingaben sind nicht plausibel.</div>),
  "sessionInvalid": () => (<div>Die Sitzung ist nicht mehr gültig.<br/>Bitte melde dich erneut an.</div>),
  "unknownError": (errorCode) => (<div>Es ist ein unbekannter Fehler mit der Nummer {errorCode} aufgetreten.<br/>Bitte setze dich mit einem Ansprechpartner von histomania in Verbindung.</div>),
  "hideStory": () => (<><Typography color="inherit">hiStory ausblenden</Typography>
    <hr/>
    Du findest diese hiStory nach dem Ausblenden schnell wieder mit der Suche unter <br/><em>'vor kurzem gesehen'</em>.</>),
  "showStory": () => (<><Typography color="inherit">hiStory anzeigen</Typography>
    <hr/>
    Die hiStory in einem neuen Tab öffnen und die Timeline parallel zu bestehenden Timelines hinzufügen.</>),
  "showStory2": "hiStory anzeigen",
  "restrictYourSearch": (totalcnt) => ("Zu viele Ergebnisse (" + totalcnt + "). Bitte schränke die Suchanfrage weiter ein."),
  "allowGeoLocation": "Bitte erlaube zunächst in den Einstellungen, dass histomania auf deinen Standort zugreifen darf.",
  "everytime": "jederzeit",
  "everywhere": "überall",
  "myNeighbourhood": "in meiner Nähe",
  "inNeighbourhood": "in der Nähe von",
  "search2": "Suche",
  "currentView": () => (<>aktuelle<br/>Ansicht</>),
  "recentlySeen2": () => (<>vor kurzem<br/>gesehen</>),
  "myStories2": () => (<>meine<br/>hiStories</>),
  "searchPhrase": "Suchbegriffe",
  "inputSearchPhrase": "Suchbegriff eingeben",
  "searchPhraseSample": "z.B.: Physiker Albert",
  "minimumCharacters": (minSearchWordCharCnt) => ("mindestens " + minSearchWordCharCnt + " Zeichen pro Suchbegriff"),
  "when": "Ereigniszeitraum",
  "where": "Ort",
  "inNeighbourhoodOf": "in der Nähe von ...",
  "chosenPosition": "gewählte Position",
  "latitude": "Breitengrad",
  "longitude": "Längengrad",
  "searchTimelines": "hiStories suchen",
  "searchStoriesInNeighbourhood": "Suche nach hiStories in der Nähe",
  "resultsFromLocalSearch": "Ereignisse aus der lokalen Suche (anklicken für Details):",
  "recommended": "Empfohlene hiStories",
  "todaysBirthdays": "Geburtstage heute",
  "todaysDeathdays": "Todestage heute",
  "anniversaries": "Jahrestage von Ereignissen heute",
  "hideAll": "Alle ausblenden",
  "inCurrentView": "in aktueller Ansicht",
  "privateTimeline": "private hiStory",
  "less": "weniger...",
  "image": "Bild",
  "logoURL": "https://" + window.location.host,
  "wikiLicenseCCSA": (site) => (<>Quelle: de.wikipedia.org - Der Text ist unter der Lizenz <a target="_blank" rel="noopener noreferrer" href={"https://de.wikipedia.org/wiki/Wikipedia:Lizenzbestimmungen_Creative_Commons_Attribution-ShareAlike_3.0_Unported"}>„Creative Commons Attribution/Share Alike“</a> verfügbar.<br/>Hier findest du die Liste der <a target="_blank" rel="noopener noreferrer" href={"https://xtools.wmflabs.org/articleinfo-authorship/de.wikipedia.org/" + site + "?uselang=de"}>Autoren</a>.</>),
  "wikiURL": "https://de.wikipedia.org/wiki/",
  "infiniteCalendarHeaderFormat": "dddd, D MMM",
  "resetfilter": "Filter zurücksetzen",
  "maintainEventList": "Ereignisse tabellarisch pflegen",
  "importcsv": "Von CSV importieren",
  "import": "Importieren",
  "prenameError": "Bitte gib deinen Vornamen ohne Ziffern und Sonderzeichen ein. Ein Vorname muss mindestens zwei Zeichen lang sein.",
  "surnameError": "Bitte gib deinen Nachnamen ohne Ziffern und Sonderzeichen ein. Ein Nachname muss mindestens zwei Zeichen lang sein.",
  "mailError": "Bitte gib eine gültige E-Mailadresse an, damit wir dir einen Bestätigunglink schicken können.",
  "fonts": "Schriftarten...",
  "bold": "fettgedruckt",
  "italic": "kursiv",
  "underline": "unterstrichen",
  "code": "Code",
  "unorderedList": "ungeordnete Liste",
  "orderedList": "geordnete Liste",
  "quote": "Zitat",
  "codeblock": "Codeblock",
  "divider": "Horizontaler Trennstrich",
  "alignment": "Textausrichtung...",
  "addImage": "Bild hinzufügen",
  "addVideo": "Video hinzufügen",
  "addMap": "Landkarte hinzufügen",
  "addPanorama": "360°-Ansicht hinzufügen",
  "addQuiz": "Quiz hinzufügen",
  "addInfoblock": "Info-Block hinzufügen",
  "addLink": "markierten Text mit Website verlinken",
  "addEvent": "markierten Text mit Ereignis in Timeline verlinken",
  "addStory": "markierten Text mit hiStory verlinken",
  "addFilter": "markierten Text mit Filter verlinken",
  "landingpage_title": "Die Plattform für Geschichte am Zeitstrahl",
  "welcome.js735054413": "Entdecke die Welt der Geschichte in hiStories, der interaktiven und multimedialen Zusammenstellung von Timelines, Texten, Bildern, Videos, Quiz, 360° Ansichten und Landkarten.",
  "welcome.js142706916": "Gestalte eigene Timelines für deinen Lebenslauf, eine Ortschronik oder eine Lernunterstützung zu einem unvergesslichen Erlebnis.",
  "welcome.js737110502": "in meiner Umgebung",
  "welcome.js455445377": "durchstöbern",
  "welcome.js695746560": "Entdecke die Welt der Geschichte in hiStories, der interaktiven und multimedialen Zusammenstellung von Timelines, Texten, Bildern und Quiz.",
  "explanation": () => (<>
    Erlebe Geschichte auf eine neue Art und Weise mit histomania, einer interaktiven Plattform, die es dir einfach macht, Geschichten zu erzählen und zu verstehen.
    <br/>
    <br/>
    Verliere die Zeit und den Ort niemals aus den Augen, während du durch tausende von Geschichten und Biografien navigierst.
    <br/>
    Im Gegensatz zu klassischen Hypertext-Erzählungen, bei denen man nur von einem Artikel zum nächsten springen kann, enthalten die Texte in histomania zusätzliche Links, die es ermöglichen, Ereignisse auf einem Zeitstrahl oder einer Landkarte zu verfolgen.
    <br/>
    <br/>
    <PostAddIcon/>&nbsp;&nbsp;öffnet eine neue hiStory
    <br/>
    <ScheduleIcon/>&nbsp;&nbsp;zeigt dir das Ereignis im Zeitstrahl
    <br/>
    <RoomIcon/>&nbsp;&nbsp;zeigt dir die Position des Ereignisses in der Karte
    <br/>
    <Filter/>&nbsp;&nbsp;filtert Ereignisse in der Timeline und der Chronologie
    <br/>
    <br/>
    Erforsche die Größenordnungen von Zeiträumen, indem du Zeitstrahlen verschiedener hiStories miteinander vergleichst und die Abstände zwischen Ereignissen innerhalb dieser Zeitstrahlen vermisst.
    <br/>
    Durch Vergleich und Vermessung wird es dir möglich, die Zeiträume und Epochen der Geschichte auf eine neue Art und Weise zu erschließen.
    <br/>
    <br/>
    Nutze interaktive Karten, die neben Pins für Positionsmarkierungen auch Pfeilketten für Reiserouten und Overlays zur Darstellung von Gebieten enthalten können.
    <br/>
    Diese können sogar animiert sein und eine von dir gewählte Transparenzstufe haben, was dir ein einzigartiges Verständnis von Grenzveränderungen ermöglicht.
    <br/>
    <br/>
    Entdecke Geschichten in deiner aktuellen Umgebung oder wenn du in einer fremden Stadt unterwegs bist einfach auf Knopfdruck.
    Finde die passenden Geschichten in Museen über einen QR-Code.
    <br/>
    <br/>
    Du kannst sogar deine liebsten hiStories in deine eigene Homepage einbetten.
    <br/>
    <br/>
    Egal, ob du eigene hiStories veröffentlichen oder nur durch die Geschichte surfen möchtest, histomania ist der ideale Begleiter für Schüler im Geschichtsunterricht, Studenten der Geschichtswissenschaft, Historiker, Ortschronisten und alle, die einfach Spaß an Geschichte oder aktuellen Ereignissen in Politik und Weltgeschehen haben.
  </>),
  "topfacts_wiki": () => (<span>Gibt es zu einer Geschichte, oder einem Ereignis in der Geschichte einen entsprechenden Artikel auf Wikipedia, oder Videos auf YouTube?<br/>Oder falls ein Ereignis örtlich bestimmt ist, möchtest du es auf einer Google Maps Karte ansehen, und dich über diese ggf. gleich dort hin navigieren lassen?<br/>Mit einem Klick landest du von den Details in histomania auf der entsprechenden Seite.</span>),
  "topfacts.js415020171": "surfen",
  "topfacts.js111683501": "vergleichen",
  "topfacts.js56475656": "integrieren",
  "topfacts.js939157228": "kostenlos",
  "topfacts.js617723463": "messen",
  "topfacts.js692398414": "erstellen",
  "topfacts.js899063949": "fiktive Fragen",
  "topfacts.js152860411": "teilen",
  "topfacts.js55830277": "verlinkt",
  "topfacts.js335278155": "suchen",
  "topfacts.js150418448": "geräteunabhängig",
  "topfacts.js820645511": "vom Urknall bis zum Weltuntergang",
  "topfacts.js645936163": "Durch die Verlinkung von geschichtlichen Ereignissen kannst du von einer Geschichte zur anderen navigieren.",
  "topfacts.js751322491": "histomania ermöglicht es dir, mehrere Zeitstrahlen untereinander zu legen, und somit vergleichbar zu machen.",
  "topfacts.js921529656": "Du möchtest Geschichten in deine eigene Webseite oder deinen Blog einbinden? Erfahre hier mehr.",
  "topfacts.js895080977": "histomania ist in der Basisversion kostenlos. Egal, ob du es für private, kommerzielle, oder Bildungszwecke einsetzt.",
  "topfacts.js948823105": "Wie viele Jahre ist Marilyn Monroe älter als James Dean? Wie alt war Einstein, als er den Nobelpreis bekam? Miss die Zeiten, die dich auf dem Zeitstrahl interessieren, einfach per integriertem Messschieber.",
  "topfacts.js107256625": "Schreib deine eigene Geschichte. Stelle geschichtliche Ereignisse so dar, dass das gezeigt wird, was dir wichtig ist. Oder beschreibe Deinen Lebenslauf auf einem Zeitstrahl.",
  "topfacts.js102762366": "Was wäre wenn... du beispielsweise zur gleichen Zeit wie Goethe geboren worden wärst? Erstelle deinen Lebenslauf, und verschiebe ihn so, dass du ihn mit dem von anderen vergleichen kannst.",
  "topfacts.js373990748": "Arbeite gemeinsam mit anderen auf einem Zeitstrahl und bestimme über Berechtigungen, wer deine Geschichte sehen oder bearbeiten darf.",
  "topfacts.js809530473": "Neben der Suche von Schlagwörtern kannst du auch danach suchen, was in bestimmten Zeiträumen an bestimmten Orten geschehen ist. Bist du an einem fremden Ort und möchtest mehr über die Geschichte der Gegend erfahren? Klicke auf 'Was ist in der Nähe?' und suche mit einem GPS-fähigen Smartphone nach Ereignissen im Umkreis.",
  "topfacts.js15371141": "Ob auf einem Smartphone, einem Tablet oder dem PC. Mit histomania hast du eine Anwendung die sich auf alle Geräte anpasst, sei es auf die Bildschirmgröße, oder auf die Art der Eingabe per Maus oder Touch-Gesten.",
  "topfacts.js678201177": "histomania kann unglaublich große Zeiträume mit einstellbarer, bis zu minutengenauer Präzision, verarbeiten. Somit können sowohl die Epochen der Erdgeschichte, als auch die Geschichte der ersten Mondlandung sinnvoll dargestellt werden.",
  "contact": "Kontakt",
  "phone": "Telefon",
  "newHiStoryMessage": () => (<span>Deine neue hiStory ist jetzt erstellt.<br/>Füge nun Ereignisse hinzu.</span>),
  "histomaniamain.js218992075": "Bitte mindestens einen Administrator angeben.",
  "menu.js844059924": "Neue hiStory",
  "storydetailsmain.js785302558": "neue hiStory",
   "storydetailsmain.js382589702": "hiStory",
  "mainFab.js309680386": 'hiStory bearbeiten',
  "mainFab.js593675655": 'Ereignisse in Tabelle pflegen',
  "mainFab.js968262525": 'Ereignis hinzufügen',
  "mainFab.js943257132": 'neue hiStory',
  "bookmarks.js93045028": "Lesezeichen",
  "menu.js505082777": "Neues Ereignis",
  "menu.js756551371": "Was wäre wenn...?",
  "menu.js663038438": "Was wäre, wenn... rückgängig machen",
  "menu.js439620799": "Lesezeichen",
  "menu.js157014000": "Drucken und Bildexport",
  "menu.js555525792": "Import/Export",
  "menu.js923812869": "Profilverwaltung",
  "menu.js450602741": "Mein Profil",
  "menu.js984392851": "Passwort ändern",
  "menu.js498764961": "Sprache",
  "menu.js869701443": "Deutsch",
  "menu.js503793771": "Englisch",
  "menu.js161223496": "Ukrainisch",
  "menu.js961199351": "Meine Einstellungen",
  "menu.js165576261": "Abmelden",
  "menu.js972296370": "Anmelden",
  "bargroup.js313011152": "Bezeichnung",
  "bargroup.js999078620": "neue Bezeichnung",
  "barshape.js677799618": "fetter Balken",
  "barshape.js210728036": "schmaler Balken",
  "barshape.js708427194": "geschweifte Klammer",
  "barshape.js853386386": "transparenter Hintergrund",
  "barshape.js709767519": "kleiner Stern",
  "barshape.js620435244": "Stern",
  "barshape.js170641551": "kleiner Kreis",
  "barshape.js649456610": "Kreis",
  "barshape.js494726977": "Wolke",
  "barshape.js735933567": "Sprechblase",
  "barshape.js931763133": "Text mittig",
  "barshape.js931763134": "Nur Grundlinie",
  "barshape.js509994468": "kleines Dokument",
  "barshape.js848987645": "Dokument",
  "barshape.js786118528": "kleine Sonne",
  "barshape.js560723628": "Sonne",
  "barshape.js624588809": "kleines Kreuz",
  "barshape.js33818872": "Kreuz",
  "barshape.js597772577": "kleiner Pfeil links",
  "barshape.js170062957": "Pfeil links",
  "barshape.js731660847": "kleiner Pfeil rechts",
  "barshape.js233359132": "Pfeil rechts",
  "dataset.js729839193": "Fehler in der Beschreibung",
  "dataset.js345733057": "Bezeichnung",
  "dataset.js850812704": "Einheit",
  "descriptionBlock.js240405443": "Beschreibung",
  "descriptionBlock.js884402762": "Hier kannst du auch Bilder und Videos einfügen.",
  "designBlock.js426292766": "Gestaltung",
  "designBlock.js902377753": "So stellt sich das Ereignis in der Timeline dar.",
  "imageBlock.js428756050": "Bild",
  "imageBlock.js604367201": "Dieses Bild erscheint in der Timeline. Weitere Bilder kannst du in der Beschreibung einfügen.",
  "imageBlock.js399000806": "Bildlizenz",
  "imagechooser.js38403923": "Bildlizenz",
  "innerevents.js238036015": "Innere Zeiten",
  "sourceReferenceBlock.js99152413": "Quellenangaben",
  "sourceReferenceBlock.js484508229": "Liste hier die Quelle(n) auf, die das Ereignis belegen.",
  "timeBlock.js186865327": "Zeit",
  "timeBlock.js929675741": "Setze für vorchristliche Zeiten ein Minus vor das Jahr, z.B. 21.04.-753",
  "timeBlock.js910792715": "Zeitpunkt",
  "timeBlock.js134397445": "Zeitraum",
  "titleBlock.js239194644": "Titel",
  "titleBlock.js47802846": "Du kannst mehrere Zeilen verwenden.",
  "wikipediareference.js851003152": "deutsche Wikipediaseite (oder Länderkürzel in eckigen Klammern voranstellen, z.B. [uk])",
  "bookmarkitem.js608408822": "Löschen",
  "story.js915248213": "Meine hiStory",
  "drafteditortoolbar.js858681026": "Schriftart",
  "drafteditortoolbar.js823346092": "Absatz",
  "drafteditortoolbar.js97337207": "Medien",
  "drafteditortoolbar.js82711167": "Links",
  "chooseImageDialog.js542504966": "Titel",
  "chooseMapDialog.js901660970": "Bezeichnung der Karte",
  "chooseMapDialog.js589922616": "Bezeichnung",
  "chooseMapDialog.js87695793": "Google Maps URL",
  "chooseMapDialog.js10384243": "Bildbeschreibung und Lizenz",
  "chooseStreetViewDialog.js854616579": "Titel",
  "chooseStreetViewDialog.js119725327": "Streetview embed code",
  "chooseVideoDialog.js778434054": "Titel",
  "chooseVideoDialog.js671606307": "YouTube-URL oder ID",
  "chooseVideoDialog.js799772333": "Start bei Sekunde",
  "AddVideoButton.js665672521": "Einen Zeitstrahl kostenlos erstellen",
  "maintenanceEventList.js998639033": "Ereignisse",
  "filtertimeline.js710501750": "Ereignisse filtern",
  "searchfield.js825023426": "hiStories nach diesem Begriff durchsuchen",
  "searchfield.js18900516": "hiStories in meiner Umgebung",
  "searchfield.js363834300": "hiStories nach Zeit und Ort suchen",
  "searchfield.js644144191": "Meine hiStories",
  "searchfield.js660560315": "Vor kurzem gesehene hiStories",
  "searchfield.js961730789": "Aktuelle Timeline mit diesem Begriff filtern",
  "searchfield.js867502466": "Aktuelle Timeline filtern",
  "searchfield.js829902906": "Suchvorschläge",
  "histomaniamain.js781485964": "Mein Ereignis",
  "histomaniamain.js702299662": "Bitte öffne oder erstelle zunächst eine hiStory um das Ereignis anzulegen.",
  "histomaniamain.js197615179": "Vorsicht beim Teilen deiner URL.\nDeine hiStory ist privat und kann nicht von allen Empfängern gesehen werden.",
  "histomaniamain.js12025145": "Bitte gib einen Titel mit mindestens drei Buchstaben für deine hiStory an.",
  "histomaniamain.js310062970": "Um die hiStory längere Zeit zu speichern musst du dich anmelden.",
  "histomaniamain.js5248846": "Bitte öffne zunächst eine hiStory, die du bearbeiten darfst, um das Ereignis dort hin zu kopieren.",
  "histomaniamain.js513585760": "springe zu",
  "import.js261569334": "Bitte öffne zunächst eine hiStory um die Ereignisse dort abzulegen.",
  "import.js67411235": "Wähle die hiStory, in die die Ereignisse abgelegt werden sollen.",
  "login.js758426829": "Melde dich an",
  "login.js779088926": "E-Mail",
  "login.js163307733": "Passwort",
  "login.js293038552": "angemeldet bleiben",
  "login.js116720706": "Noch kein Konto?",
  "login.js319559879": "Vorname",
  "login.js278946069": "Bitte einen Vornamen angeben",
  "login.js897560837": "Nachname",
  "login.js237687098": "Bitte einen Nachnamen angeben",
  "login.js457756656": "E-Mail",
  "login.js692708124": "Bitte einen gültigen Benutzernamen angeben",
  "login.js368777066": "Passwort vergessen?",
  "login.js327950210": "E-Mail",
  "login.js493155713": "Anmeldung",
  "editMediaDialog.js254758074": "Medienliste",
  "editMediaDialog.js106456795": "JSON",
  "markdowneditfield.js110445871": "Panoramaansicht bearbeiten",
  "markdowneditfield.js117272661": "Quiz bearbeiten",
  "markdowneditfield.js848013488": "Medienelement bearbeiten",
  "lazygooglemap.js947359452": "Ich bin damit einverstanden, dass mir Inhalte von Google-Maps angezeigt werden. Hierdurch können personenbezogene Daten an Dritte übermittelt werden.",
  "QuizEditorTitlePage.js823814415": "Titel",
  "menu.js893403567": "Teilen",
  "menu.js932778276": "als E-Mail",
  "menu.js556545983": "Daten exportieren",
  "menu.js413767225": "Daten importieren",
  "menu.js990897862": "Hilfe",
  "menu.js171939370": "von ",
  "print.js570625276": "Die Mindestbreite beträgt ",
  "print.js612051645": "Die Maximalbreite beträgt ",
  "print.js574630162": "Die minimale Balkenhöhe beträgt ",
  "print.js760791437": "Die maximale Balkenhöhe beträgt ",
  "print.js758964558": "Der maximale Überstand wurde überschritten.",
  "print.js375853243": "Der Überstand darf nicht negativ sein.",
  "print.js15990392": "Es muss mindestens ein horizontaler Teil zum Drucken vorhanden sein.",
  "print.js556329669": "Es muss mindestens ein vertikaler Teil zum Drucken vorhanden sein.",
  "print.js833055774": "Das Bild darf nicht in mehr als 100 Teile geschnitten werden.",
  "printdialog.js85755474": "Überstand wegen Beschriftung (",
  "printdialog.js341020472": "transparenter Hintergrund",
  "printdialog.js665169354": "Schatten zeichnen",
  "printdialog.js605134089": "horizontal",
  "printdialog.js839026585": "vertical",
  "displaystorydetails.js158045992": "Quellen",
  "addstorydescriptor.js92624992": "Eingebettete hiStories",
  "addstorydescriptoreditdialog.js502574362": "Gruppe",
  "addstorydescriptoreditdialog.js124818429": "ID der hiStory",
  "addstorydescriptoreditdialog.js117860561": "ungefilterte Ereignis-IDs",
  "addstorydescriptoreditdialog.js777122119": "Position",
  "backgroundimageinput.js816937029": "Bild",
  "backgroundimageinput.js218259721": "Dieses Bild dient als Hintergrund der Timeline und erscheint in der Suche. Weitere Bilder kannst du in der Beschreibung einfügen.",
  "backgroundimageinput.js429573179": "Bildlizenz",
  "userrightsdialog.js70424287": "Benutzer suchen",
  "userrightsdialog.js480394996": "E-Mail",
  "userrightsdialog.js216158241": "Bitte eine gültige E-Mailadresse angeben",
  "bookingrightsadministration.js589033383": "Berechtigungen",
  "bookingrightsadministration.js546709873": "jeder darf die hiStory lesen",
  "descriptioninput.js517543907": "Beschreibung",
  "dummyuserhint.js499234330": "Du bist nicht angemeldet",
  "headlineinput.js150642075": "Überschrift",
  "headlineinput.js593049979": "Titel der hiStory",
  "headlineinput.js477282705": "Subtitel",
  "newstoryhint.js799008560": "Erste Schritte",
  "sourcereferenceinput.js783166353": "Quellenangaben",
  "wikipediainput.js705594377": "Erweiterte Inhalte",
  "search.js726564732": "Suche",
  "search.js671154469": "jederzeit",
  "durationpanel.js274332505": "unbekannte Dauer",
  "searchfield.js807364549": "In aktueller Timeline suchen",
  "histomaniamain.js734544182": "Die hiStory wird nur für deine Sitzungsdauer gespeichert.",
  "menu.js698756284": "Eventuell bisher testweise gemachte Änderungen werden zurückgesetzt",
  "userrightsdialog.js937814759": "Berechtigung bearbeiten",
  "bargroup.js45524065": "Bezeichnung überall ändern",
  "sourceReferenceBlock.js304249147": "Quellenangaben für das Ereignis angeben.",
  "timeBlock.js20893151": "Innere Zeiten...",
  "wikipediareference.js907588328": "Ich möchte einen Wikipedia-Artikel einbetten.",
  "bookmarkdialog.js412170740": "Lesezeichen zufügen",
  "bookmarkdialog.js929413458": "Du bist nicht angemeldet. Deine Lesezeichen bleiben nur für etwa einen Tag gültig.",
  "bookmarks.js475765892": "offene Timelines als Lesezeichen speichern",
  "bookmarks.js306859711": "Wirklich löschen?",
  "cookieconsent.js905029185": "Wir verwenden Cookies und localStorage-Einträge. Deine Einstellungen kannst du jederzeit über das Menü in der App anpassen. Wenn du nicht alle Cookies oder localStorage-Einträge akzeptieren möchtest, oder du mehr darüber erfahren willst, dann klicke auf 'Mehr anzeigen'.",
  "cookieconsent.js352836975": "Mehr anzeigen",
  "cookieconsent.js243259253": "Schließen",
  "cookieconsent.js645797755": "Alle Cookies annehmen",
  "schoolcookieconsent.js905029185": () => <>Wir verwenden auf schule.histomania.com nur technisch notwendige Cookies und localStorage-Einträge, die nicht abgelehnt werden könnnen.<br/>Hierzu zählen ein Sessioncookie und localStorage-Einträge, die die Sprachauswahl, Kennzeichen für den Benutzer, damit er sich nicht wiederholt anmelden muss, sowie das Bestätigen dieses Fensters speichern.<br/></>,
  "schoolcookieconsent.js645797755": "OK",
  "drafteditortoolbar.js747935826": "Schriftart",
  "drafteditortoolbar.js616605922": "Absatz",
  "drafteditortoolbar.js894699961": "Medien",
  "drafteditortoolbar.js109669568": "Links",
  "chooseMapDialog.js417538297": "Schritt 2:",
  "chooseMapDialog.js561133791": "Schritt 3:",
  "chooseMapDialog.js61491380": "übernehmen",
  "Link.js291014714": "hiStory öffnen",
  "Link.js62298905": "Ereignisse in Timeline filtern",
  "maintenanceeventlisttable.js380608930": "Bezeichnung",
  "maintenanceeventlisttable.js866297000": "Start",
  "maintenanceeventlisttable.js573824846": "Ende",
  "filtertasklist.js930196063": "Alle",
  "filtertasklist.js18265885": "Alle Ereignisse",
  "filtertasklist.js560877919": "Begriff",
  "filtertasklist.js132146692": "Zeitraum",
  "filtertasklist.js8240783": "Eigenschaften",
  "filtertasklist.js192609356": "Zeitpunktereignisse",
  "filtertasklist.js774361819": "Zeitraumereignisse",
  "filtertasklist.js700792519": "Gruppen",
  "filtertasklist.js482827431": "Einzelereignisse",
  "extendedmenu.js908817077": "Drucken und Bildexport",
  "extendedmenu.js336969410": "Lesezeichen",
  "extendedmenu.js82030918": "Einstellungen",
  "extendedmenu.js7002811": "Hilfe",
  "extendedmenu.js598943965": "Sprache",
  "extendedmenu.js760560118": "Home",
  "histomaniamain.js114097156": "Komplette Timeline in sichtbaren Bereich",
  "import.js191606136": "CSV-Import",
  "import.js112638704": "Kopiere den Inhalt deiner CSV-Datei in das Textfeld und klicke auf 'Import'.",
  "login.js382006560": "Abonniere auch gleich den histomania-Newsletter.",
  "login.js416865926": "Nutzungsbedingungen",
  "login.js64439934": "Datenschutzerklärung",
  "login.js572661779": "Ich habe die Nutzungsbedingungen und die Datenschutzerklärung gelesen und akzeptiere diese",
  "login.js230957075": "Konto erstellen",
  "login.js878212959": "Neues Passwort zusenden",
  "editMediaDialog.js808123558": "Medien",
  "markdowneditfield.js554353551": "Schriftarten",
  "markdowneditfield.js558691581": "Überschrift 1",
  "markdowneditfield.js785963602": "Überschrift 2",
  "markdowneditfield.js935699377": "Überschrift 3",
  "markdowneditfield.js534085527": "Überschrift 4",
  "markdowneditfield.js518723970": "Überschrift 5",
  "markdowneditfield.js452157683": "Überschrift 6",
  "markdowneditfield.js267080676": "Kursiv (selektierter Text)",
  "markdowneditfield.js267174421": "Fett Kursiv (selektierter Text)",
  "markdownhelper.js160663836": "Medienelement konnte nicht gefunden werden",
  "markdownhelper.js744897963": "Filter",
  "markdownhelper.js297030165": "Ort anzeigen",
  "markdownhelper.js702490738": "externe Webseite öffnen",
  "quizErrorDialog.js818208140": "Es ist ein Titel für das Quiz erforderlich.",
  "quizErrorDialog.js316989684": "Bitte gib mindestens eine Frage an.",
  "quizErrorDialog.js217047946": "Frage #{index+1}: Gib die Frage an.",
  "quizErrorDialog.js592184179": "Frage #{index+1}: Gib höchstens vier Antworten an.",
  "quizErrorDialog.js91808612": "Frage #{index+1}: Markiere mindestens eine korrekte Antwort über die Checkboxen.",
  "quizErrorDialog.js770785722": "Frage #{index+1}: Gib mindestens eine Antwort an.",
  "quizErrorDialog.js121149031": "Frage #{index+1}, Antwort #{answerIndex+1}: Eine leere Antwort ist nicht erlaubt.",
  "lazygooglemap.js821091857": "Leider können dir in dieser Subdomain aus datenschutzrechtlichen Gründen keine Inhalte von Google-Maps angezeigt werden.",
  "media.js334165907": "Fehler in der Kartenbeschreibung",
  "media.js745432641": "Fehler in der Kartenbeschreibung",
  "QuizEditorTitlePage.js567873608": "Startseite",
  "QuizEditorTitlePage.js3575109": "Beschreibung",
  "QuizQuestion.js522602069": "Formuliere hier deine Frage",
  "QuizQuestion.js277305215": "Füge Antworten hinzu und setze ein Häkchen bei den korrekten Antworten",
  "QuizQuestion.js719954254": "Hier kann eine Erklärung der Antwort angefügt werden",
  "QuizQuestion.js631196400": "So viele Punkte soll es bei einer richtigen Antwort geben",
  "streetview.js903524730": "Leider können dir in dieser Subdomain aus datenschutzrechtlichen Gründen keine Inhalte von Google-Maps angezeigt werden.",
  "youtube.js541386012": "Leider können dir in dieser Subdomain aus datenschutzrechtlichen Gründen keine Inhalte von YouTube angezeigt werden.",
  "circularmenu.js381995722": "Suchen",
  "circularmenu.js524039849": "Zeitabstände in der Timeline messen",
  "circularmenu.js739065959": "Benutzerdefinierte Einstellungen",
  "circularmenu.js357509198": "Lesezeichen",
  "circularmenu.js636940232": "Alle Gruppen ein-/ausklappen",
  "circularmenu.js355370525": "Eine neue hiStory erstellen",
  "circularmenu.js753068960": "Ein Zeitpunkt-Ereignis erstellen",
  "circularmenu.js653781889": "Ein Zeitabschnitt-Ereignis erstellen",
  "menu.js826958696": "Datenschutzerklärung",
  "menu.js586813367": "AGB und Nutzungsbedingungen",
  "menu.js614038001": "Impressum",
  "menu.js439856996": "Bildlizenzen",
  "menu.js942699906": "Cookie-Einstellungen rücksetzen",
  "printdialog.js317202399": "Auflösung",
  "printdialog.js176250960": "Zeitbereich",
  "printdialog.js161420731": "Bildeinstellungen",
  "printdialog.js399246718": "Bild teilen",
  "printdialog.js150161449": "Vorschau",
  "printdialog.js8964786": "Drucken",
  "printdialog.js544885797": "Bildexport",
  "ratings.js661212453": "Um bewerten zu können musst du dich anmelden.",
  "displaystorydetails.js121722705": "Bildlizenzen anzeigen",
  "bookingrightsadministration.js131215424": "Diese Benutzer dürfen die hiStory bearbeiten:",
  "dummyuserhint.js706662830": ()=><>Ohne Anmeldung kannst du eine hiStory nur zu <b>Testzwecken</b> erstellen, diese wird jedoch nach einiger Zeit wieder gelöscht.</>,
  "newstoryhint.js223326167": () => (<>Hier erzählst du deine hiStory, die den Rahmen für deine Timeline bildet.<br/>Fürs Erste reicht es aber aus, wenn du deiner hiStory nur einen Titel gibst und dann speicherst.<br/>Danach kannst du mit der Eingabe der einzelnen Ereignisse beginnen.</>),
  "bookingrights.js286057285": "Die hiStory darf von ",
  "distributerightsdialog.js87761818": "Rechte verteilen",
  "barexpansion.js878339034": "Höhe",
  "barexpansion.js887101724": "-fach",
  "barexpansion.js728758094": "Lege die angezeigte Höhe des Ereignisses als ein Vielfaches der normalen Höhe fest.",
  "bargroup.js152857522": "Gruppe",
  "bargroup.js914347576": "Bezeichnung ändern",
  "barposition.js84416775": "Position",
  "barposition.js560624624": "Bestimme über die Position, welche Ereignisse weiter unten, und welche weiter oben angezeigt werden sollen.",
  "barsettings.js434654385": "Farbe",
  "barsettings.js408327828": "Wähle die Farbe für das Ereignis. Die Schriftfarbe wird automatisch ausgewählt.",
  "barshape.js315964835": "Form",
  "barshape.js230080019": "Wähle die Form des Ereignisbalkens.",
  "dataset.js205796920": "Diagrammdaten",
  "dataset.js666145317": "Beschreibe zeitabhängige Diagramme.",
  "dataset.js354018274": "Füge hier den CSV-Inhalt ein und drücke OK:",
  "dataset.js218289977": "Importieren",
  "editbookingdetails.js985514551": "Möchtest das Ereignis du wirklich löschen?",
  "imagechooser.js862610110": "Bild an Ereignis in Timeline",
  "imagechooser.js871519548": "Bestimme ein Bild, das in der Timeline erscheint.",
  "imagechooser.js950070103": "Weitere Bilder kannst du in der Beschreibung hinzufügen.",
  "wikipediareference.js272862577": "Wikipedia-Referenz",
  "wikipediareference.js904830442": "Verweis auf Wikipedia.",
  "bookmarks.js523603774": "Möchtest du das Lesezeichen '{deleteBookmarkS && deleteBookmarkS.name}' wirklich löschen?",
  "chooseMapDialog.js720327007": "Gib die Bezeichnung an.",
  "chooseMapDialog.js760709110": "Klicke dann in die Karte, um einen neuen Marker zu setzen, oder gib die URL von Google-Maps ein.",
  "chooseMapDialog.js388797867": "Gib die Bildbeschreibung und die Lizenz an, falls dein Bild nicht lizenzfrei ist.",
  "chooseMapDialog.js842057153": "Passe die Größe in der Karte an. Füge Kontrollpunkte (mindestens drei) mit [Ctrl + Click] hinzu.",
  "chooseMapDialog.js982829124": "Wähle dann ",
  "Link.js776621301": "Ereignis in Timeline",
  "Link.js501324063": "Eine weitere hiStory öffnen.",
  "import.js93314536": "Import von JSON",
  "import.js254441848": "Import von Textfeld",
  "login.js15485281": "Bitte gib deine bei histomania hinterlegte E-Mail-Adresse ein:",
  "markdowneditfield.js426937653": "Fett (selektierter Text)",
  "markdowneditfield.js85888028": "Bild einfügen",
  "markdowneditfield.js249402737": "Video einfügen",
  "markdowneditfield.js421012641": "Karte einfügen",
  "markdowneditfield.js535534111": "Panoramaansicht einfügen",
  "markdowneditfield.js58232052": "Filter einfügen",
  "markdowneditfield.js954635745": "Quiz einfügen",
  "markdowneditfield.js827493202": "Liste aller Medien",
  "markdownhelper.js904359583": "Ereignisse in Chronologie und Timeline filtern.",
  "markdownhelper.js133555219": "Ereignis in Timeline finden",
  "markdownhelper.js499018470": "Ein Pfeil zeigt dir die Position des Ereignisses im Zeitstrahl.",
  "markdownhelper.js743956038": "Die Position des Ereignisses wird auf einer Karte angezeigt.",
  "markdownhelper.js813604085": "Ein neuer Browsertab wird mit dem Artikel geöffnet.",
  "addstorydescriptor.js556883219": "Eingebettete hiStories",
  "addstorydescriptor.js110462036": "neue eingebettete hiStory",
  "bookingrights.js50879320": "Melde dich an, um hiStories mit anderen zu teilen.",
  "admincomponent.js149123880": "Schließen",
  "loginbutton.js370395105": "anmelden / kostenlos registrieren",
  "mediaitemlistbutton.js846631503": "Liste aller Medien",
  "registerbutton.js180629076": "kostenlos registrieren",
  "hintdialog.js158836303": "Schließen",
  "barexpansion.js805637512": "normal",
  "barexpansion.js271938727": "25-fach",
  "barexpansion.js680468558": "50-fach",
  "barexpansion.js321153821": "75-fach",
  "barexpansion.js970143224": "100-fach",
  "barposition.js477225547": "ganz unten",
  "barposition.js21166688": "normal",
  "barposition.js400652493": "ganz oben",
  "bookingrightsadministration.js501993017": "Weiteren Benutzer berechtigen",
  "streetview.js459438593": "Ich bin damit einverstanden, dass mir Inhalte von Google-Maps angezeigt werden. Hierdurch können personenbezogene Daten an Dritte übermittelt werden.",
  "displaystorydetails.js463453345": "Ereignisse. Klicke einen Eintrag für Details oder das Uhrensymbol zum Finden im Zeitstrahl",
  "dataset.newLine": "neue Zeile",
  "dataset.fromCSV": "von csv",
  "markdowneditfield.name": "Name",
  "markdowneditfield.birth": "Geburtsdatum",
  "addmarkdownbutton.53645": "Dies ist eine Markdown-Überschrift",
  "timeblock.3457335": "Gib entweder die Dauer oder das Ende an, der andere Wert wird jeweils berechnet. Ohne Angabe geht das Ende bis zur aktuellen Zeit.",
  "innerevents.34353463": "Zur Zeit steht nur der JSON-Editor zur Eingabe zur Verfügung.",
  "bargroup.54345345": "Ereignisse der gleichen Gruppe werden in einem beschrifteten Block in der Timeline dargestellt.<br/>Gruppenbezeichnungen sind case-sensitiv, d.h. es wird zwischen Groß- und Kleinschreibung unterschieden.",
  "cookieconsent.0": "Bevor du fortfährst",
  "cookieconsent.1": "Technisch notwendige Cookies",
  "cookieconsent.2": () => <>Betriebstechnische Cookies können nicht deaktiviert werden, da ansonsten unsere Seite nicht mehr funktionieren kann.<br/>Wir verwenden beispielsweise Session-Cookies um die aktuelle Auswahl deiner hiStories zu speichern.<br/>Des Weiteren können in benutzergenerierten Inhalten Seiten von YouTube und Google-Maps eingebettet sein.<br/>Auch hierdurch können Cookies seitens der genannten Hersteller gesetzt werden. <br/>Wir fragen dich vor dem Laden dieser Inhalte noch einmal vorher ab, ob du dies möchtest.<br/>Deine Auswahl merken wir uns im Local Storage des Browsers.<br/><br/></>,
  "cookieconsent.3": "Analyse-Cookies",
  "cookieconsent.4": "Wir verwenden Google-Analytics um Statistiken zu erstellen. Dabei werden keine personenbezogenen Daten verarbeitet. IP-Adressen werden anonymisiert gespeichert (die letzten Stellen werden durch ein X ersetzt).",
  "cookieconsent.5": "Du kannst die Cookie und Local Storage Einstellungen jederzeit widerrufen, indem du im Menü 'Cookie-Einstellungen rücksetzen' wählst.",
  "enlargeToSelection": "auf Auswahl vergrößern",
  "fixDuration": "Dauer fixieren",
  "endMeasurement": "Messung beenden",
  "secondsFromNow": "Sekunden ab jetzt",
  "minutesFromNow": "Minuten ab jetzt",
  "hoursFromNow": "Stunden ab jetzt",
  "daysFromNow": "Tage ab jetzt",
  "chronology": "Chronologie",
  "languageinput.js593099979": "Sprache",
  "fontSettings.js878339034": "Schrift",
  "fontSettings.js887101724": "-fach",
  "fontSettings.js728758094": "Lege die Höhe der Beschriftung als ein Vielfaches der normalen Höhe fest.",
  "fontSettings.quarter": "1/4",
  "fontSettings.half": "1/2",
  "fontSettings.threequarters": "3/4",
  "fontSettings.full": "normal",
  "fontSettings.oneandahalf": "1,5-fach",
  "fontSettings.two": "doppelt",
  "fontSettings.transparency": "Undurchsichtigkeit",
  "fontSettings.height": "Höhe",
  "fontSettings.25percent": "25%",
  "fontSettings.50percent": "50%",
  "fontSettings.75percent": "75%",
  "fontSettings.100percent": "100%",
  "fontSettings.bold": "fett",
  "fontSettings.italic": "kursiv",
  "deleteProfile": "Mein Profil löschen",
  "deleteProfileContent": () => <>Das Löschen deines Profils löscht nicht deine hiStories.<br/>Diese bleiben ggf. für andere Benutzer unter einem anonymisierten Profil sichtbar.<br/>Möchtest du, dass deine hiStories nicht mehr für andere zugänglich sind, dann lösche diese, bevor du dein Profil löschst.<br/><br/>Möchtest du dein Profil unwiderruflich löschen?</>,
  "menu.mapForTimeInterval": "Zusammengefasste Karte aus Zeitintervall",
  "relation.js272862577" : "Verbindungslinien",
  "relation.js904830442" : "Verbindungslinien",
  "connection.target" : "Verknüpfungsziel",
  "connection.name" : "Bezeichnung",
  "connection.color" : "Farbe",
  "connection.width" : "Breite",
  "connection.textpos" : "Textposition",
  "connection.startpos" : "Startposition",
  "connection.endpos" : "Endposition",
  "schoolclass6" : "6",
  "schoolclass7" : "7",
  "schoolclass8" : "8",
  "schoolclass9" : "9",
  "schoolclass10" : "10",
  "schoolclass11" : "+",
  "curriculum.title" : "hiStories nach Schulklassen",
  "curriculum.text" : "Hier findest du ausgewählte hiStories nach Schulklassen geordnet. Da jedes Bundesland seinen eigenen Lehrplan hat, ist die Einteilung nur grob möglich.",
  "welcome.about" : "Über histomania",
  "pricingbutton.text" : "Preise",
  "pricing.free" : "Kostenlos",
  "pricing.school" : "Schule",
  "pricing.plus" : "Plus",
  "pricing.freebody" : () => <><h2 style={{display: 'inline-block'}}>0,<span style={{verticalAlign: 'super', fontSize: '0.75em'}}>00</span> €</h2><br/>kostenlose Basisversion für private, kommerzielle oder Bildungszwecke.<br/><br/><hr/><br/><ul><li>dauerhaft kostenlos</li><li>Einbindung der Timelines in eigene Websites</li><li>Erstellung eigener hiStories</li></ul></>,
  "pricing.schoolbody" : () => <span>ab <h2 style={{display: 'inline-block'}}>2,<span style={{verticalAlign: 'super', fontSize: '0.75em'}}>40</span> €</h2> / Schüler / Jahr<br/>Für Anmeldungen per VIDIS, edulog, mit Schul-E-Mailadressen oder individuell konfiguriert.<br/><br/>ab einer Lehrkraft und 10 Sch&uuml;lern/Studenten<br/><br/><hr/><br/><ul><li>Volle Sichtbarkeit kostenpflichtiger Inhalte</li><li>Erstellung privater Inhalte</li><li>Beschränkt auf schule.histomania.com</li><li>geprüft</li><li>werbefrei</li></ul></span>,
  "pricing.plusbody": () => <span>ab <h2 style={{display: 'inline-block'}}>29,<span style={{verticalAlign: 'super', fontSize: '0.75em'}}>90</span> €</h2> / Benutzer / Jahr<br/>Für private und geschäftliche Nutzer.<br/><br/><hr/><br/><ul><li>Volle Sichtbarkeit kostenpflichtiger Inhalte</li><li>Erstellung privater Inhalte</li><li>Exportmöglichkeit</li><li>werbefrei</li></ul></span>,
  "pricing.configureAndOrder": "Konfigurieren und buchen",
  "licenses": "Lizenzen",
"licenseCard.determineUsers": "Hier kannst Du bestimmen, welche Benutzer bei der Anmeldung deine Lizenz verwenden dürfen.",
"licenseCard.recognizeUsers": "Anhand welcher Merkmale können Benutzer erkannt werden, die sich mit dieser Lizenz anmelden dürfen?",
"licenseCard.schoolVidisEduca": "Schule (nur VIDIS oder EDUCA)",
"licenseCard.stateVidisEduca": "Bundesland (nur VIDIS oder EDUCA)",
"licenseCard.mailDomain": "Maildomain",
"licenseCard.username": "Benutzername",
"licenseCard.schoolLicense": "Schullizenz",
"licenseCard.plusLicense": "Plus-Lizenz",
"licenseCard.purpose": "Verwendungszweck",
"licenseCard.orderDate": "Bestellung vom",
"licenseCard.validity": "Gültigkeit",
"licenseCard.loginType": "Lehreranmeldungen",
"licenseCard.userLoginType": "Benutzeranmeldungen",
"licenseCard.studentLogins": "Schüler/Studenten-Anmeldungen",
"licenseCard.status": "Status",
"licenseCard.paid": "bezahlt",
"licenseCard.paymentPending": "Zahlung offen",
"licenseCard.billingAddress": "Rechnungsadresse",
"licenseCard.showAddress": "Rechnungsadresse einblenden",
"menu.onFacebook": "auf Facebook",
"menu.onTwitter": "über Twitter",
"menu.onWhatsApp": "über WhatsApp",
"menu.embedStory": "hiStory einbetten",
"menu.qrCode": "QR-Code",
"listMenu.nestedListFacebook": "Eine Timeline auf",
"listMenu.nestedListTwitter": "Eine Timeline auf",
"listMenu.nestedListWhatsApp": "Eine Timeline auf",
"listMenu.nestedListMailSubject": "Timeline auf",
"embed.title": "Einbetten",
"embed.showHeader": "Kopfzeile einblenden",
"embed.showArticle": "Artikel einblenden",
"embed.darkBackground": "Hintergrund der Timeline dunkel",
"embed.showBgImage": "Bild im Hintergrund der Timeline anzeigen",
"embed.showFab": "Floating Action Button sichtbar",
"embed.htmlSnippet": "HTML-Schnipsel",
"sourceReference.uneImgAlt": "Eine Abbildung von ",
"import.title": "Import",
"import.warnTitle": "Warnung",
"import.csvTextLabel": "CSV-Text",
"import.description": ()=><>Zeilen, die nicht importiert werden konnten bleiben nach dem Import im Textfeld stehen<br/>Eine Beschreibung des benötigten Formats findest du</>,
"import.here": "hier",
"qrCodePage.title": "QR-Code",
"qrCodePage.instruction": "Du kannst diesen QR-Code speichern und ausdrucken.",
"qrCodePage.downloadButton": "Download im svg-Format",
"histomaniamain.sessionover": "Deine Session ist abgelaufen.",
"histomaniamain.checkconnection": "Bitte prüfe die Internetverbindung.",
"histomaniamain.isLoading": "wird geladen...",
"histomaniamain.pleasewait": "bitte warten",
"histomaniamain.whatif": "was wäre, wenn...",
"histomaniamain.pressHere": "Drücke hier 2 Sekunden, um ein neues Ereignis zu erstellen",
"histomaniamain.chooseStoryForNewEvent": "Wähle die hiStory für das neue Ereignis.",
"export.title": "Export",
"export.lockWarningText": "Die Export-Funktionalität steht nicht zur Verfügung. Erfahre mehr über den vollen Zugriff",
"pricing.maturity": "Die Laufzeit der Lizenz beträgt 12 Monate und verlängert sich nicht automatisch, außer nach gesonderter Vereinbarung.",
"pricing.subdomain": "Benötigst du eine eigene Subdomain auf histomania.com oder hast Probleme mit der Finanzierung an deiner Schule?",
"pricing.testAgreement": "Hättest du gerne eine individuelle Testvereinbarung?",
"pricing.contactUs": "Egal welche individuelle Anforderung du hast, schreib uns an",
"pricing.vatIncluded": "Unsere Preise verstehen sich inklusive Mehrwertsteuer.",
"pricing.findSolution": "Wir finden eine gemeinsame Lösung.",
"priceLegendSchool.pricesPerYearPerUser": "Preise pro Jahr und Anwender",
"priceLegendSchool.teachers": "Lehrende",
"priceLegendSchool.from5Teachers": "ab 5 Lehrenden",
"priceLegendSchool.from10Teachers": "ab 10 Lehrenden",
"priceLegendSchool.students": "Schüler",
"priceLegendSchool.from100Students": "ab 100 Schülern",
"priceLegendSchool.from300Students": "ab 300 Schülern",
"priceLegendPlus.pricesPerYearPerUser": "Preise pro Jahr und Anwender",
"priceLegendPlus.oneToFourUsers": "1-4 Anwender",
"priceLegendPlus.fiveToTwentyUsers": "5-20 Anwender",
"priceLegendPlus.twentyOneToNinetyNineUsers": "21-99 Anwender",
"priceLegendPlus.hundredOrMoreUsers": "ab 100 Anwendern",
"priceCalculator.errorOccurred": "Beim Übermitteln der Daten ist ein Fehler passiert.",
"priceCalculator.contactSupport": "Bitte wende dich direkt per E-Mail an bestellung@histomania.com.",
"priceCalculator.licenseConfig": "Lizenzkonfiguration für",
"priceCalculator.schools": "Schulen und Träger",
"priceCalculator.privateUsers": "private und geschäftliche Nutzer",
"priceCalculator.howManyUsers": "Wie viele verschiedene Anwender werden maximal pro Jahr mit histomania arbeiten?",
"priceCalculator.numTeachers": "Anzahl Lehrende",
"priceCalculator.numUsers": "Anzahl Anwender",
"priceCalculator.atLeastOne": "Es wird mindestens ein",
"priceCalculator.calculated": "berechnet.",
"priceCalculator.numStudents": "Anzahl Schüler/Studenten",
"priceCalculator.atLeastTenStudents": "Es werden mindestens 10 Schüler/Studenten berechnet.",
"priceCalculator.validFrom": "Gültig ab",
"priceCalculator.totalPrice": "Gesamtpreis:",
"priceCalculator.perYear": "pro Jahr",
"priceCalculator.billingAddress": "Rechnungsadresse",
"priceCalculator.purchaseInfo": "Für eine Bestellung benötigst du ein histomania-Konto und musst du angemeldet sein.",
"priceCalculator.profileManagement": "Nach der Bestellung kannst du unter dem Menüpunkt 'Profilverwaltung | Lizenzen' den Status deiner Lizenz einsehen und die Zugänge konfigurieren.",
"priceCalculator.defineUsers": "Dort definierst du auch die Einzelbenutzer oder Benutzergruppen, die sich mit dieser Lizenz anmelden dürfen.",
"priceCalculator.includesTax": "Unsere Preise verstehen sich inklusive 19% deutscher Mehrwertsteuer.",
"priceCalculator.foreignOrders": "Bei Bestellungen aus dem Ausland können im Empfängerland Steuern anfallen, deren Zahlung in der Verantwortung des Käufers liegt.",
"priceCalculator.chooseFutureDate": "Bitte wähle ein gültiges Datum, das heute oder in der Zukunft liegt.",
"orderError.orderErrorOccurred": "Bei deiner Bestellung ist ein Fehler aufgetreten.",
"orderError.contactSupport": "Bitte melde dich bei info@histomania.com direkt.",
"checkout.pleasePayAmount": "Bitte zahle den Betrag von",
"checkout.within14Days": "innerhalb von 14 Tagen auf folgendes Konto:",
"checkout.peterRankSoftware": "Peter Rank Software",
"checkout.accountNumber": "Kontonummer: DE55 7019 0000 0007 5237 42",
"checkout.bankCode": "Bankleitzahl: GENO DEF1 M01 (Münchner Bank e.G.)",
"checkout.paymentReference": "Verwendungszweck:",
"checkout.payConveniently": "Oder zahle schnell und bequem per Kreditkarte, Klarna, Bancontact oder eps-Überweisung:",
"checkout.continueToStripe": "Weiter zum Zahlungsdienstleister Stripe",
"checkout.specifyReference": "Gib bitte unbedingt in jedem Fall den Verwendungszweck",
"checkout.findNumberProfile": "Du findest diese Nummer auch unter dem Menüpunkt 'Profilverwaltung | Lizenzen' und auf deiner Rechnung.",
"checkout.configureLicenses": "Dort kannst du auch deine Lizenzen konfigurieren.",
"checkout.toLicenseAdmin": "Zur Lizenzverwaltung",
"checkout.noNeedToWait": "Du brauchst nicht zu warten, bis die Buchung deiner Zahlung erfolgt ist.",
"checkout.fullAccess": "Wir haben dir jetzt schon deinen vollen Zugang für die nächsten 14 Tage freigeschaltet.",
"checkout.reviewOrder": "Wir werden deine Bestellung prüfen und dir eine Rechnung mit Zahlungsinformationen an die angegebene E-Mail-Adresse schicken.",
"checkout.noNeedToWaitInvoice": "Du brauchst nicht zu warten, bis du die Rechnung erhältst und die Zahlung erfolgt ist.",
"checkout.toLicenseAdminLower": "zur Lizenzverwaltung",
"addressForm.schoolEmptyError": "Schule/Träger darf nicht leer sein.",
"addressForm.prenameEmptyError": "Vorname darf nicht leer sein.",
"addressForm.surnameEmptyError": "Nachname darf nicht leer sein.",
"addressForm.streetEmptyError": "Straße darf nicht leer sein.",
"addressForm.streetNumberEmptyError": "Hausnummer darf nicht leer sein.",
"addressForm.zipCodeInvalidError": "Postleitzahl muss 5 Ziffern haben.",
"addressForm.townEmptyError": "Stadt darf nicht leer sein.",
"addressForm.countryEmptyError": "Land darf nicht leer sein.",
"addressForm.emailInvalidError": "Ungültige E-Mail-Adresse.",
"addressForm.countryLabel": "Land",
"addressForm.germany": "Deutschland",
"addressForm.austria": "Österreich",
"addressForm.switzerland": "Schweiz",
"addressForm.taxNumberLabel": "Steuernummer",
"addressForm.taxNumberHelper": "Falls ihre Organisation eine Steuernummer besitzt",
"addressForm.schoolOrOrgLabel": "Schule/Träger",
"addressForm.companyLabel": "Firma",
"addressForm.prenameLabel": "Vorname",
"addressForm.surnameLabel": "Nachname",
"addressForm.streetLabel": "Straße",
"addressForm.streetNumberLabel": "Hausnummer",
"addressForm.zipCodeLabel": "Postleitzahl",
"addressForm.townLabel": "Stadt",
"addressForm.emailLabel": "E-Mail-Adresse",
"zoomableImage.bild": "Bild: ",
"editButton.bearbeiten": "Bearbeiten",
"pregnancyDialog.yourPregnancyCalendar": "Dein Schwangerschaftskalender",
"pregnancyDialog.enterDate": "Trag das Datum deiner letzten Periode oder das Datum der Befruchtung ein, um deinen individuellen Schwangerschaftskalender zu sehen.",
"pregnancyDialog.firstDayLastPeriod": "Erster Tag der letzten Periode",
"pregnancyDialog.dayOfFertilization": "Tag der Befruchtung",
"pregnancyDialog.from": "von",
"pregnancyDialog.loading": "Loading...",
"pregnancyDialog.whatIf": "was wäre, wenn...",
"pregnancyDialog.firstDayLastPeriodTask": "Erster Tag der letzten Periode",
"despotbirthday.title": "Vergleich dich mit Despoten",
"despotbirthday.prompt": "Was wäre, wenn die Despoten des 20. Jahrhunderts mit dir geboren worden wären?",
"despotbirthday.chooseBirthday": "Gib deinen Geburtstag an, und du kannst sehen, was andere Gewaltherrscher in deinem Alter bereits erreicht hatten.",
"despotbirthday.label": "Wann ist dein Geburtstag?",
"despotbirthday.loading": "Loading...",
"usersPerDay.newUsers": "Neue Benutzer pro Tag",
"usersPerDay.day": "Tag",
"usersPerDay.count": "Anzahl",
"users.loadingError": "Fehler beim Laden der Benutzerdetails",
"users.privilegesError": "Fehler beim Setzen der Adminprivilegien",
"users.countText": "Benutzer, davon",
"users.validatedText": "validiert",
"users.newsletterSubscribersText": "Newsletterabonenten, davon",
"users.headingUsers": "Benutzer",
"users.emailHeading": "EMail",
"users.forenameHeading": "Vorname",
"users.surnameHeading": "Nachname",
"users.newsletterHeading": "Newsletter",
"users.validatedHeading": "Validiert",
"users.numHistories": "Anzahl hiStories",
"userDetails.hiStories": "hiStories",
"userDetails.id": "ID",
"userDetails.name": "Name",
"userDetails.public": "öffentlich",
"userDetails.adminPrivileged": "Admin berechtigt",
"userDetails.events": "Ereignisse",
"userDetails.lastEventChange": "letzte Ereignisänderung",
"userDetails.lastStoryChange": "letzte Storyänderung",
"topVisited.topPages": "Top besuchte Seiten",
"topVisited.visits": "Besuche",
"topVisited.page": "Seite",
"topVisited.creator": "Ersteller",
"topVisited.events": "Ereignisse",
"topVisited.creationTime": "Erstellungszeitpunkt",
"topTaskCnt.title": "Seiten mit vielen Ereignissen",
"topTaskCnt.visits": "Besuche",
"topTaskCnt.page": "Seite",
"topTaskCnt.creator": "Ersteller",
"topTaskCnt.events": "Ereignisse",
"topTaskCnt.creationTime": "Erstellungszeitpunkt",
"search.from": "von",
"search.to": "bis",
"titlelist.ago": (years)=>"vor "+years+" Jahren",
"deleteDialog.title": "Wirklich löschen?",
"deleteDialog.confirmationText": "Möchtest du die hiStory du wirklich löschen?",
"dummyUserHint.warningText": "Testzwecken erstellen, diese wird jedoch nach einiger Zeit wieder gelöscht.",
"dummyUserHint.notPublished": "Du kannst diese hiStory auch nicht veröffentlichen.",
"dummyUserHint.notAddedToAccount": "Die hiStory wird auch nicht in dein Konto übernommen wenn du dich anmeldest.",
"dummyUserHint.logonHere": "Melde dich",
"dummyUserHint.here": "hier",
"bookingRightsAdmin.notAvailable": "Die Berechtigungsvergabe steht nicht zur Verfügung.",
"bookingRightsAdmin.publiclyAccessible": "Die neue hiStory ist öffentlich zugänglich.",
"bookingRightsAdmin.learnMore": "Erfahre mehr über das Freischalten der Berechtigungen.",
"userrightsdialog.userneverloggedin":"Der Benutzer hat sich noch nie angemeldet",
"displayStoryDetails.publishPrompt": "Veröffentliche diese hiStory, damit sie jeder finden und sehen kann:",
"displayStoryDetails.publishNow": "Jetzt veröffentlichen",
"displayStoryDetails.storyProtected": "Diese hiStory ist geschützt.",
"displayStoryDetails.textScrambled": "Buchstaben in Texten wurden durcheinandergewürfelt.",
"displayStoryDetails.learnMoreFullAccess": "Erfahre mehr über den vollen Zugriff.",
"displayStoryDetails.map": "Karte",
"displayStoryDetails.mindmap": "Mindmap",
"displayStoryDetails.position": "Position",
"printdialog.barSizeLabel": "Balkenhöhe [px]",
"printdialog.widthLabel": "Breite [px]",
"printdialog.heightLabel": "Höhe [px]",
"printdialog.altText": "Vorschau",
"printdialog.from": "von",
"printdialog.to": "bis",
"print.legendSource": "Quelle",
"menu.active": "aktiv",
"youtube.consentLabel": "Ich bin damit einverstanden, dass mir Inhalte von YouTube angezeigt werden. Hierdurch können personenbezogene Daten an Dritte übermittelt werden.",
"mediaFile.mapTooltip": "Karte anzeigen",
"mediaFile.videoTooltip": "Video anzeigen",
"mediaFile.streetViewTooltip": "StreetView anzeigen",
"mediaFile.quizTooltip": "Quiz anzeigen",
"googleMapContent.undurchsichtig": "undurchsichtig",
"googleMapContent.durchsichtig": "durchsichtig",
"googleMapContent.transparenz": "Transparenz",
"googleMapContent.gitter": "Gitter",
"googleMapContent.kontrollpunkte": "Kontrollpunkte",
"googleMapContent.overlay": "Overlay",
"quizQuestion.question": "Frage",
"quizQuestion.addAnswer": "Antwort hinzufügen",
"quizQuestion.addExplanation": "Hier klicken um eine Erklärung einzufügen",
"quizEditor.addQuestion": "Frage hinzufügen",
"quizAnswer.antwort": "Antwort ",
  "quiz.landingHeaderText": (nrOfQuestions)=> nrOfQuestions+" Fragen",
  "quiz.question": "Frage",
  "quiz.startQuizBtn": "Starte das Quiz",
  "quiz.resultFilterAll": "Alle",
  "quiz.resultFilterCorrect": "richtig",
  "quiz.resultFilterIncorrect": "falsch",
  "quiz.nextQuestionBtn": "Weiter",
  "quiz.resultPageHeaderText": (correctlength, questionslength)=>"Du hast "+correctlength+" von "+questionslength+" Fragen richtig beantwortet.",
  "quiz.resultPagePoint": (correctPoints, totalPoints)=>"Du bekommst "+correctPoints+" von "+totalPoints+" Punkten.",
  "quiz.singleSelectionTagText": "Einfachauswahl",
  "quiz.multipleSelectionTagText": "Mehrfachauswahl",
  "quiz.pickNumberOfSelection": (numberOfSelection) => "Wähle "+numberOfSelection+" Antworten aus",
  "quiz.pickNumberOfSelectionSingle": "Wähle eine Antwort aus",
  "quiz.auswertung": "Auswertung",
"instantFeedback.correctMessage": "Richtig! Bitte klicke auf Weiter, um fortzufahren.",
"instantFeedback.incorrectMessage": "Falsche Antwort. Bitte versuche es noch einmal.",
"markdowneditfield.videoEdit": "Video bearbeiten",
"markdowneditfield.mapEdit": "Karte bearbeiten",
"markdowneditfield.insertTable": "Tabelle einfügen",
"markdowneditfield.hr": "Horizontale Linie einfügen",
"markdowneditfield.linkWith": "Markierten Text mit hiStory, Ereignis oder Filter verlinken",
"markdowneditfield.convertToBullet": "Markierten Text in Aufzählung umwandeln",
"markdowneditfield.convertToQuote": "Markierten Text in Zitat umwandeln",
"markdowneditfield.preview": "Vorschau",
"markdowneditfield.mdFormatting": "(Markdown-Formatierung möglich)",
"textField.ariaSearch": "Suche",
"filterTimeline.tip": "Tipp: Klicke zunächst das durchgestrichene Auge bei 'Alles' um alle Ereignisse wegzufiltern und füge dann schrittweise Ereignisse hinzu.",
"filterTimeline.showIds": "Zeige IDs der ungefilterten",
"maintenanceeventlisttable.andauernd": "andauernd",
"maintenanceeventlisttable.clickToEdit": "Klicke in die gewünschte Tabellenzelle zum Bearbeiten oder '...' um zu den Details zu gelangen.",
"maintenanceeventlisttable.autoSaveInfo": "Jede Änderung wird sofort gespeichert, sobald du die Tabellenzelle verlässt.",
"addPanoramaButton.title": "Brandenburger Tor",
"imageButton.title": "Mein Bild",
"chooseMarkdownDialog.markdown": "Markdown",
"chooseMarkdownDialog.leftMargin": "linker Abstand",
"chooseMarkdownDialog.rightMargin": "rechter Abstand",
"chooseMapDialog.selectedPosition": "gewählte Position",
"chooseMapDialog.marker": "Marker",
"chooseMapDialog.arrow": "Pfeil",
"chooseMapDialog.overlay": "Overlay",
"chooseMapDialog.newMarker": "neuer Marker",
"chooseMapDialog.newArrow": "neuer Pfeil",
"chooseMapDialog.newOverlay": "neues Overlay",
"chooseMapDialog.arrowInstruction": "Klicke den Pfad des Pfeils und am Ende auf ",
"chooseMapDialog.overlayStep1": "Schritt 1:",
"chooseMapDialog.uploadImage": "Lade dein Bild und bestimme den Ausschnitt",
"chooseMapDialog.pointEndInstruction": "Entferne Punkte mit [Shift + Click].",
"chooseInfoBlock.infoblock": "Infoblock",
"chooseInfoBlock.backgroundColor": "Hintergrundfarbe",
"chooseInfoBlock.leftMargin": "linker Abstand",
"chooseInfoBlock.rightMargin": "rechter Abstand",
"chooseMapDialog.click": "Klicke den Pfad des Pfeils und am Ende auf",
"chooseMapDialog.or": "oder",
"chooseMapDialog.takeover": "übernehmen",
"bookmarks.jsSaveBookmark": "als Lesezeichen speichern",
"bookmarkItem.js.foundStories": (size)=>"(Zusammenfassung von "+size+" hiStories)",
"bookmarkdialog.name": "Name",
"editbookingdetails.reallydelete": "Wirklich löschen?",
"editbookingdetails.newEvent": "Neues Ereignis",
"editbookingdetails.event": "Ereignis",
"dataset.csvimport": "CSV-Import",
"dataset.table": "Tabelle",
"dataset.json": "JSON",
"connections.newConnection": "neue Verbindung",
  "menu.france": "Französisch",
  "menu.italy": "Italienisch",
"nomoretwitter": ()=><>Bisher hast du dich hier über deinen Twitter/X-Account angemeldet.<br/>Fordere einfach über "Passwort vergessen" ein neues Passwort an deine Twitter/X-Mailadresse an und logge dich dann direkt bei uns ein.</>,
  "langNotAvailable": "Die gewünschte Sprache ist leider nicht verfügbar für",
  "and": "und",
  "menu": "Menü",
}

export default res